<template>
    <header id="site-header" :class="{ stuck }" role="navigation">
        <top-bar />
        <nav-bar />
    </header>
</template>

<script>
  import TopBar from './TopBar.vue';
  import NavBar from './NavBar.vue';

  export default {
    name: 'SiteHeader',
    data() {
      return {
        stuck: false,
      };
    },
    mounted() {
      window.addEventListener('scroll', () => {
        this.stuck = window.pageYOffset > 104;
      });
    },
    computed: {},
    components: {
      TopBar,
      NavBar,
    },
  };
</script>

<style lang="scss">
    .stuck {
        .topbar {
            margin-top: -40px;
        }
    }
</style>
